import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import moment from 'moment';
import API from '../Helper/server/API';
import { _endPoints } from '../Helper/links';
import { Avatar } from 'primereact/avatar';
import imgCustomer from "../public/images/user.avif";
import { View_control_expired, View_date_created, View_date_login, View_date_logout, View_DeviceSystem, View_ip_address_login, View_token_firebase } from '../constants/dataView';
import { Toast } from 'primereact/toast';

const UserDetailsView = ({ id_user }) => {
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [userLogs, setUserLogs] = useState([]);
    const toast = useRef(null);


    useEffect(() => {
        if (id_user) {
            fetchUserDetails();
        }
    }, [id_user]);

    const fetchUserDetails = async () => {
        setLoading(true);
        const response = await API.get(`${_endPoints.users_app.get_user}?id_user=${id_user}`);
        if (response?.success) {
            setUserData(response.user);
            setUserLogs(response.logs);
        }
        setLoading(false);
    };

    const dateBodyTemplate = (rowData) => {
        return moment(rowData.date_login).format('YYYY-MM-DD HH:mm:ss');
    };

    const logoutDateBodyTemplate = (rowData) => {
        return rowData.date_logout && rowData.date_logout !== 'null' ? moment(rowData.date_logout).format('YYYY-MM-DD HH:mm:ss') : '-';
    };

    const stateBodyTemplate = (rowData) => {
        return rowData.state_log ? (
            <span style={{ color: "green" }}>نشط</span>
        ) : (
            <span style={{ color: "red" }}>منتهي</span>
        );
    };

    if (loading) {
        return (
            <div className="p-4" dir="rtl">
                <Skeleton width="100%" height="80px" className="mb-4" />
                <Skeleton width="100%" height="300px" />
            </div>
        );
    }

    return (
        <div className="p-2" dir="rtl" style={{ fontFamily: "Cairo" }}>
            <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />

            <div className='col-md-12'>
                <div className='row'>

                    <div className='col-md-2 pt-5'>
                        <div class="media-img">
                            <center>
                                <Avatar image={userData?.image ? `${_endPoints.users.images}${userData?.image}` : imgCustomer} className="flex mr-2" size="xlarge" style={{ width: "150px", height: "150px", transition: "transform 10s ease" }} shape="circle" />
                            </center>
                        </div>
                    </div>

                    <div className='col-md-10'>

                        <hr></hr>
                        <br></br>
                        <div className='row'>
                            <div className="col-md-4 col-12  mb-4 font-bold" >
                                <div class="media-heading font-16" >
                                    <i class="ti-user font-26 text-muted ml-3" dir='rtl'></i>
                                    {userData?.name ? <>{userData?.name}</> : <>-</>}
                                </div>
                            </div>
                            <div className="col-md-4 col-12  mb-4 font-bold" >
                                <div class="media-heading font-16" >
                                    <i class="fa fa-phone font-26 text-muted ml-3 pt-1"></i>
                                    <a dir='ltr' href={`tel:${userData?.country_code}-${userData?.phone}`} target="_blank" rel="noopener noreferrer">+{userData?.country_code}-{userData?.phone}</a>
                                </div>
                            </div>
                            <div className="col-md-4 col-12  mb-4 font-bold" >
                                <div class="media-heading font-16" >
                                    <i class="fa fa-whatsapp font-26 text-muted ml-3 pt-1"></i>
                                    {userData?.whatsapp_number ? <><a dir='ltr' href={`https://wa.me/${userData?.whatsapp_number}`} target="_blank" rel="noopener noreferrer">+{userData?.whatsapp_number}</a></> : '-'}
                                </div>
                            </div>
                        </div>
                        <hr></hr>
                        <br></br>
                        <div className='row'>
                            <div className="col-md-4 col-12  mb-4 font-bold" >
                                <div class="media-heading font-16" >
                                    <i class="pi pi-star font-26 text-muted ml-3 pt-1"></i>
                                    <p style={{ display: "inline" }}>
                                        {userData.control_points}
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4 col-12  mb-4 font-bold" >
                                <div class="media-heading " >
                                    حظر حتى  :
                                    <br></br>
                                    {View_control_expired(userData)}

                                </div>
                            </div>
                            <div className="col-md-4 col-12  mb-4 font-bold" >
                                <div class="media-heading " >
                                    تاريخ الإضـافة :

                                    {View_date_created(userData)}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <h5 className="mb-3">سجل تسجيل الدخول ( Logs - {userLogs.length} ) </h5>
            <DataTable value={userLogs} scrollHeight='600px' rows={5} className="p-datatable-sm" responsiveLayout="scroll" emptyMessage={<center className='font-bold m-5'>لا توجد سجلات دخول لهذا المستخدم</center>}>
                <Column field="system" header="النظام" sortable style={{ textAlign: "right" }} body={View_DeviceSystem} />
                <Column field="id_device" header="معرف الجهاز" sortable style={{ textAlign: "right" }} />
                <Column field="model" header="الموديل" sortable style={{ textAlign: "right" }} />
                <Column field="token_firebase" header="اشعارات" sortable style={{ textAlign: "right" }} body={(e) => View_token_firebase(e, toast)} />

                <Column field="ip_address_login" body={View_ip_address_login} header="عنوان IP" sortable style={{ textAlign: "right" }} />
                <Column field="date_login" header="تاريخ الدخول" body={View_date_login} sortable style={{ textAlign: "right" }} />
                {/* <Column field="date_logout" header="تاريخ الخروج" body={View_date_logout} sortable style={{ textAlign: "right" }} /> */}
                <Column field="state_log" header="الحالة" body={stateBodyTemplate} sortable style={{ textAlign: "right" }} />
            </DataTable>
        </div>
    );
};

export default UserDetailsView;
